export const styles = {
	bottomOffset: {
		marginBottom: '12px'
	},
	divider: {
		marginBottom: '16px',
		marginTop: '8px'
	}
};
